import { Bomb, Check, CircleAlert, Info, XIcon } from 'lucide-react';
import { FC } from 'react';

import { cn } from '@/utils/cn';

import { InternalNotificationItem } from './internal-notifications-store';

const Notification: FC<{
  value: InternalNotificationItem;
  onClose: () => void;
}> = ({ value, onClose }) => {
  return (
    <div
      className={cn(
        ['flex', 'items-center', 'gap-2'],
        'rounded-md',
        'bg-white',
        'p-2',
        'drop-shadow-[5px_5px_5px_rgba(0,0,0,0.25)]',

        // Animation
        value.isOpen ? 'opacity-100' : 'opacity-0',
        'transition-all',
        'duration-1000',
      )}
    >
      {/* Icon */}
      {value.type === 'success' ? (
        <Check className="shrink-0 text-2xl text-green-500" />
      ) : value.type === 'info' ? (
        <Info className="shrink-0 text-2xl text-sky-500" />
      ) : value.type === 'warning' ? (
        <CircleAlert className="shrink-0 text-2xl text-orange-500" />
      ) : (
        <Bomb className="shrink-0 text-2xl text-red-500" />
      )}

      {/* Messages */}
      <div className="min-w-0 flex-1">
        <p className="break-words font-bold">{value.title}</p>
        <div className="flex flex-col">
          {value.timestamp && (
            <span className="break-words text-xs text-gray-500">
              {value.timestamp.toLocaleString()}
            </span>
          )}
          {value.description && (
            <span className="break-words text-sm text-gray-700">
              {value.description.body}
            </span>
          )}
          {value.description?.url && (
            <span className="break-words text-xs text-red-900">
              {value.description?.url}
            </span>
          )}
        </div>
      </div>

      {/* Close button */}
      <div className="flex shrink-0 flex-row items-center rounded-full p-2 text-lg transition-all duration-200 hover:bg-gray-200 focus:ring-gray-300">
        <button onClick={onClose}>
          <XIcon />
        </button>
      </div>
    </div>
  );
};

Notification.displayName = 'Notification';

export { Notification };
